/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * TextBlockModal component styles
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components';

export const TextBlockModalStyled = styled.div`
    cursor: pointer;
`;
